import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createBrowserRouter } from 'react-router';
import { App } from './App';
import { DogPage } from './common/errors';
import { ProductDetailsPage } from './pages/productDetailsPage';
import { PaymentSelectionPage } from './pages/paymentSelectionPage';
import { ThankYouPage } from './pages/thankYouPage';
import { PreviewOrderPage } from './pages/previewOrderPage';
/**
 * Created a browser router that react-router uses to render the current application screen
 * based on the URL.
 *
 * TODO:
 *   - Look into lazy loading: https://reactrouter.com/start/data/route-object#lazy
 */
export const router = createBrowserRouter([
    {
        // Layout routes don't need a "path"
        Component: App,
        // If something throws an error, then the app will display the dog page
        errorElement: _jsx(DogPage, {}),
        children: [
            // Layout routes need a default Outlet
            { index: true, Component: DogPage },
            {
                path: 'checkout',
                children: [
                    { path: 'preview', Component: PreviewOrderPage },
                    { path: 'payment-selection', Component: PaymentSelectionPage },
                    { path: 'confirm', Component: ThankYouPage },
                ],
            },
            // TODO: For backwards compatibility, move to new format after launch complete
            { path: 'painter/products/details/:asin', Component: ProductDetailsPage },
            // Default fallback if invalid route
            { path: '*', Component: DogPage },
        ],
    },
]);
